<form class="k-form k-form-horizontal" style=" min-height:500px ; max-width: 700px;width: 700px;"
  [formGroup]="formGroup">
  <!-- <fieldset> -->
  <kendo-formfield orientation="horizontal">
    <kendo-label class="k-label" [for]="refModeloModulo" [text]="customMsgService.translate('modulo')"> </kendo-label>
    <kendo-dropdownlist textField="nome" valueField="id" formControlName="refModeloModulo" [defaultItem]="placeHolder"
      (selectionChange)="selectionChange($event)" [data]="listItems" #refModeloModulo required>
    </kendo-dropdownlist>
    <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
      customMsgService.translate('modulo') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

  </kendo-formfield>

  <kendo-formfield orientation="horizontal">
    <kendo-label class="k-label" [for]="megaLocker" [text]="customMsgService.translate('optionEletronica')">
    </kendo-label>
    <kendo-dropdownlist textField="nome" valueField="value" formControlName="megaLocker" [valuePrimitive]="true"
      [defaultItem]="placeHolder" [data]="listItemsEletronica" #megaLocker required>
    </kendo-dropdownlist>
    <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
      customMsgService.translate('optionEletronica') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
  </kendo-formfield>
  <br />
  <div class="card-component card-center">
    <div class="modulo-wrapper">
      <kendo-gridlayout [rows]="linhas" [cols]="colunas" [gap]="2">

        <kendo-gridlayout-item *ngFor="let c of compartimentos" [col]="c.coluna" [row]="c.linha" [rowSpan]="c.linhaSpan"
          class="box rect">
          <span>{{ c.nome }}</span>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </div>
  </div>

  <kendo-dialog-actions>

    <button kendoButton (click)="saveChanges()" themeColor="primary" [disabled]="!formGroup.valid">
      {{ customMsgService.translate('addModulos') }}
    </button>
  </kendo-dialog-actions>
</form>